// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-944e5fee]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.upload-assets__wrapper .assets-uploader[data-v-944e5fee] .el-upload{text-align:left;width:100%}.upload-assets__wrapper .overflow-widget[data-v-944e5fee]{max-height:500px;overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
